import React, { useState } from 'react';
import { Button, ButtonProps } from './Button';
import cls from 'classnames';
import styles from './HoldButton.module.scss';

export function HoldButton({
  className,
  success,
  children,
  ...rest
}: React.PropsWithChildren<HoldButtonProps>) {
  const [timer, setTimer] = useState<NodeJS.Timer | null>(null);
  const [disabled, setDisabled] = useState(false);
  const [classes, setClasses] = useState<string[]>([]);

  const duration = 1600;

  const onSuccess = () => {
    setClasses(classes.concat(styles.success));
    setDisabled(true);
    if (success) success();
  };

  const startTimer = () => {
    setClasses(classes.concat(styles.loading));
    setTimer(setTimeout(onSuccess, duration));
  };

  const resetTimer = () => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setClasses(classes.filter((x) => x !== styles.loading));
  };

  return (
    <Button
      className={cls(styles.buttonHold, className, ...classes)}
      onMouseDown={startTimer}
      onTouchStart={startTimer}
      onMouseUp={resetTimer}
      onMouseLeave={resetTimer}
      onTouchEnd={resetTimer}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
}

export type HoldButtonProps = Omit<ButtonProps, 'onClick'> & {
  success?: () => void;
};
